import React, { useState } from "react";
import { isMobile } from "react-device-detect";

import ClickAwayListener from "@mui/material/ClickAwayListener";

import { LightTooltip } from "components/Tooltip";

import { ReactComponent as InfoIcon } from "assets/images/info-icon.svg";

interface TooltipInfoIconProps {
  title: string;
  color?: string;
}

const TooltipInfoIcon: React.FC<TooltipInfoIconProps> = ({ title, color }) => {
  const [open, setOpen] = useState(false);

  if (isMobile) {
    return (
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <span>
          <LightTooltip title={title} open={open}>
            <span
              onClick={() => setOpen((prev) => !prev)}
              style={{ display: "flex" }}
            >
              <InfoIcon color={color} />
            </span>
          </LightTooltip>
        </span>
      </ClickAwayListener>
    );
  }

  return (
    <LightTooltip title={title}>
      <InfoIcon color={color} />
    </LightTooltip>
  );
};

export default TooltipInfoIcon;
